// @ts-strict-ignore
import {ChangeDetectionStrategy, Component, HostBinding, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { LMFieldBaseComponent } from '@field/lm-field-base.component';
import { LMModel } from '@form/model';
import { LMFieldServiceAdapter } from '@field/lm-field-service-adapter';
import * as urltemplate from 'url-template';
import { LMFormRequestService } from '@form/services';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector:    'lm-radiobutton',
  templateUrl: './lm-radiobutton.component.html',
  styleUrls:   [ 'lm-radiobutton.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMRadiobuttonComponent extends LMFieldBaseComponent implements OnInit, OnDestroy {
  @Input() layoutObject: LMRadioButtonLayout;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;

  public isHorizontal = false;
  private isUserDefined = false;
  public values: Array<LMStateValue> = [];

  public values$ = new BehaviorSubject<LMStateValue[]>([]);

  @HostBinding('class.field') hostClass = !this.isHorizontal;

  @HostBinding('attr.data-automation-id') dataFieldAutomationId = '';

  constructor(private lmFormRequestService: LMFormRequestService,
    protected lmFieldServiceAdapter: LMFieldServiceAdapter) {
    super(lmFieldServiceAdapter);
  }

  // the sohoxi controls will run the validation on a click and will
  // remove the alert that was placed there; listening here will re-apply the alert
  @HostListener('click', [ '$event' ])
  onClick(event) {
    this.onChangeProcessAlerts();
    super.onClick(event);
  };

  // events
  ngOnInit() {
    super.ngOnInit();
    this.initialize(this.layoutObject, this.specFields, this.model);

    this.isUserDefined = this.specField.hasUserDefinedStates;
    // field class interferes with horizontal radio buttons
    // causes last radio to display when first radiobutton (not label) is checked
    this.isHorizontal = this.field.horizontalRadioButtons;

    if (this.isUserDefined) {
      this.getUserDefinedStates();

    } else if (this.specField.stateValues) {
      this.values = this.specField.stateValues;
      this.values$.next(this.values);
    }

    this.fieldClassArray.push('radio-group');
    this.fieldClassArray.push('field-radio');
    this.setFieldClasses();

    if (!(this.displayAsText || this.displayAsTag)) {
      this.subscribeToInlineError();
    }

    this.dataFieldAutomationId = `lm-${this.fieldAutomationId}-field`;
    }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  contextMenuClicked = ($event) => {
    this.onContextMenuEvent($event);
  }

  trackByValue(index: number, state: LMStateValue) {
    return state.value;
  }

  public onNgModelChange(value) {
    this.modelField.toDataValue(value, this.transformOptions);
  }

  public getUserDefinedStates(): void {
    this.busyIndicator = true;

    const compiledFormRequestUrl = urltemplate.parse(this.model.formUrlInfo.formRequestUrl);
    const formRequestUrl = compiledFormRequestUrl.expand({ resourceId: this.model.formResourceId });

    const dataView = this.model.getData();
    const actionName = this.model.action;

    this.lmFormRequestService
      .getUserDefinedStates(formRequestUrl, this.bindId, dataView, actionName)
      .subscribe((result: LMUserDefinedResponse) => {
        if (this.lmFieldServiceAdapter.lmContextService.userDefinedStatesPageSizeAndIndicator()) {
          if (result && result.hasOwnProperty('states') && Array.isArray(result.states)) {
            this.values = this.modelField.states = this.lmFieldServiceAdapter.lmFormatUtilService.fieldStatesToOptionsArray(result.states, false);
            this.values$.next(this.values);
            return;
          }
        } else {
          if (Array.isArray(result)) {
            this.values = this.modelField.states = this.lmFieldServiceAdapter.lmFormatUtilService.fieldStatesToOptionsArray(result, false);
            this.values$.next(this.values);
            return;
          }
        }

        // an error
        this.busyIndicator = false;
        this.lmFieldServiceAdapter.lmLoggerService.error([ 'Error in getUserDefinedStates', this.bindId, result ]);
      },
      (error) => {
        this.busyIndicator = false;
        this.lmFieldServiceAdapter.lmLoggerService.error([ 'Error in getUserDefinedStates', this.bindId, error ]);
      });
  };
}
